package org.example.project.enginetabular

import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.SerialKind
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive
import org.example.project.utils.All

private val tabularCommitJson = Json {
    ignoreUnknownKeys = true
    encodeDefaults = false
}

private val allDescriptor = All.AllNames.serializer().descriptor

private fun parseBoolean(value: String): Boolean {
    return when (value.lowercase()) {
        "true", "1", "yes", "ja", "aktiv", "✅" -> true
        else -> false
    }
}

private fun parsePrimitiveValue(index: Int, raw: String): JsonPrimitive {
    val descriptor = allDescriptor.getElementDescriptor(index)
    return when (val kind = descriptor.kind) {
        PrimitiveKind.BOOLEAN -> JsonPrimitive(parseBoolean(raw))
        PrimitiveKind.INT -> JsonPrimitive(raw.toIntOrNull() ?: 0)
        PrimitiveKind.LONG -> JsonPrimitive(raw.toLongOrNull() ?: 0L)
        PrimitiveKind.FLOAT -> JsonPrimitive(raw.toFloatOrNull() ?: 0f)
        PrimitiveKind.DOUBLE -> JsonPrimitive(raw.toDoubleOrNull() ?: 0.0)
        else -> JsonPrimitive(raw)
    }
}

fun allFromTabularCommit(
    rowId: String,
    cols: List<String>,
    fieldIds: List<String>
): All {
    val content = linkedMapOf<String, kotlinx.serialization.json.JsonElement>()
    if ("id" !in fieldIds) {
        content["id"] = JsonPrimitive(rowId)
    }

    fieldIds.forEachIndexed { index, fieldId ->
        val key = fieldId
        if (key.isBlank()) return@forEachIndexed
        val descriptorIndex = allDescriptor.getElementIndex(key)
        if (descriptorIndex == -3) return@forEachIndexed

        val raw = cols.getOrNull(index).orEmpty()
        val elementDescriptor = allDescriptor.getElementDescriptor(descriptorIndex)
        val element = when (elementDescriptor.kind) {
            is PrimitiveKind -> parsePrimitiveValue(descriptorIndex, raw)
            SerialKind.ENUM -> JsonPrimitive(raw)
            else -> when (key) {
                "kontrollOptions" -> JsonArray(
                    raw.split(",").map { it }.filter { it.isNotEmpty() }.map(::JsonPrimitive)
                )
                else -> JsonPrimitive(raw)
            }
        }
        content[key] = element
    }

    return tabularCommitJson.decodeFromJsonElement(All.AllNames.serializer(), JsonObject(content))
}
